module.exports = __webpack_public_path__ + "static/media/APIStep2.ed841c49.svg";